import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import queryString from 'query-string'
import Navigation from '../Navigation'
import Footer from '../Footer'
import Button from '../Button'
import ProgressStepIndicator from '../ProgressStepIndicator'
import TextInput from '../forms/TextInput'
import { MotorService } from '../../services/motorService'
import { DealershipService } from '../../services/dealershipService'
import { AbTestService } from '../../services/abTestService'
import { Helpers } from '../../utilities/helpers'
import Validators from '../../utilities/validators'
import Alert from '../forms/Alert'
import ActivityIndicator from '../forms/ActivityIndicator'
import NumberplateInput from '../forms/NumberplateInput'
import CheckboxInput from '../forms/CheckboxInput'
import IntercomManager from '../../utilities/intercomManager'
import { tag } from '../../services/tagService'
import PopupView from '../forms/PopupView'
import {
  validationMessages,
  BLOCKED_REFFERER_URLS,
  productTypes
} from '../../utilities/enums'
import ChatBot from '../ChatBot'
import pineappleLogo from 'images/Pineapple_icon.png'
import RadioButton from '../RadioButton'
import NumberInput from '../forms/NumberInput'
import { AnalyticsManager } from '../../utilities/analyticsManager'
import posthog from 'posthog-js'
import { WillHelper } from '../../utilities/WillHelper'
import WillModal from '../WillModal'
import SmartDelayService from '../../services/smartDelayService'
class MotorGetStartedPage extends Component {
  constructor(props) {
    super(props)

    this.chatBotRef = React.createRef(null)
    this.state = {
      progressTotal: 0,
      progressCurrentPage: 0,
      validFirstName: false,
      validLastName: false,
      canSubmitForm: false,
      redirect: false,
      redirectToVehicleDetails: false,
      isRetrievingUser: false,
      hasNoNumberPlate: false,
      wantsFreePineappleWill: false,
      showWantsFreePineappleWillModal: false,
      displayDealershipCodeInput: false,
      firstName: '',
      lastName: '',
      email: '',
      contactNumber: '',
      numberPlate: '',
      showThirdPartyInfoPopup: false,
      showCreditChecksPopup: false,
      isQueryStringId: false,
      showValidateAccountPopup: false,
      verifyAccountUserId: null,
      verifyContactNumber: null,
      isSendingOtp : false,
      isConfirmingOtp: false,
      isVerifySMS: false,
      isVerifyEmail: false,
      isOtpSent: false,
      otp: null,
      experimentName: '',
      variantName: '',
      userAcceptedFreeWill: '',
      canSubmitWillLead: false,
      salesAgent: null,
      previousUrl: '',
      userId: '',
      verifyEmailAddress: '',
    }
  }

  componentDidMount = async () => {
    // page title
    document.title = 'Motor Get Started'

    // capture page view for PostHog
    AnalyticsManager.capturePageView()

    // get the agent from storage
    const salesAgent = await Helpers.getInStorage('sales_agent', true)
    if (salesAgent) {
      // reset posthog identity
      AnalyticsManager.resetUserIdentity()
      this.setState({
      salesAgent: JSON.parse(salesAgent)
    })
    }
    // check if this is a user coming from the quick start flow
    const quickStartEmailAddress = await Helpers.getInStorage('quickStartEmailAddress')
    if (quickStartEmailAddress) {
      this.setEmail(quickStartEmailAddress.trim().toLowerCase())
      await Helpers.removeFromStorage('quickStartEmailAddress')
    }

    const getParams = queryString.parse(this.props.location.search)
    const { ucid, duuid, uuid, gclid, u: userId, v: verifyEmailAddress, ved } = getParams

    if (userId && verifyEmailAddress) {
      this.setState({ userId, verifyEmailAddress  }, () => {
        this.verifyEmail()
      })
    }
    this.renderWillsProductOptInVariant(!!duuid, !!salesAgent)

    if (uuid) {
      posthog.identify(uuid)
    } else {
      posthog.reset()
    }

    const previousUrl = await Helpers.getInStorage('referrerUrl');
    Helpers.removeFromStorage('referrerUrl')

    // if userId is present in query string, send it over
    this.setState({ 
      isQueryStringId: uuid || duuid,
      userId: uuid, 
      dealershipCode: duuid, 
      ucid,
      previousUrl,
      ved: !!ved,
    },
    async () => {
      const promises = [
        duuid && this.retrieveDealership(),
        ucid && Helpers.setInStorage('ucid', `${ucid}`, true),
        gclid && Helpers.setInStorage('gclid', `${gclid}`, true),
      ];
      await Promise.all(promises.filter(Boolean));
      uuid && this.retrieveUser();
    })

    // if pid is Email_Jag_Method set externalLeadSource to jag_method
    if (getParams.pid && getParams.pid === 'Email_Jag_Method') {
      await Helpers.setInStorage('externalLeadSource', 'jag_method')
    }

    await Helpers.removeFromStorage('vehicle-image')

    // JagMethod Tracking Pixel
    const jagMethodPixelScript = document.createElement('script')
    jagMethodPixelScript.type = 'text/javascript'
    jagMethodPixelScript.src = 'https://dripple.quickinsure.co.za/px/__px.js'

    document.body.appendChild(jagMethodPixelScript)

    this.chatBotRef.current.speak('GetStarted_General_Greet')
  }

  componentDidUpdate = (prevProps, prevState) => {
    // update form validness
    if (
      prevState.firstName !== this.state.firstName
      || prevState.lastName !== this.state.lastName
      || prevState.email !== this.state.email
      || prevState.contactNumber !== this.state.contactNumber
      || prevState.numberPlate !== this.state.numberPlate
      || prevState.hasNoNumberPlate !== this.state.hasNoNumberPlate
    ) {
      this.setState({
        canSubmitForm:
          Validators.isName(this.state.firstName)
          && Validators.isName(this.state.lastName)
          && Validators.isEmail(this.state.email)
          && Validators.isCellNo(this.state.contactNumber)
          && (
            !this.state.hasNoNumberPlate && Validators.isNumberPlate(this.state.numberPlate)
            || this.state.hasNoNumberPlate
          )
      }, () => {
        this.state.canSubmitForm && this.chatBotRef.current.speak('startPromt')
      })

      this.setState({
        canSubmitWillLead: false // hide will leads temporarily
          // Validators.isName(this.state.firstName)
          // && Validators.isName(this.state.lastName)
          // && Validators.isEmail(this.state.email)
          // && Validators.isCellNo(this.state.contactNumber)
      })
      this.getFormProgress()
    }
  }
  getWillLeadDetails = () => {
    const { firstName, lastName, email, contactNumber } = this.state

    return { first_name: firstName,
      last_name: lastName,
      email: email,
      contact_number: contactNumber
    }

  }

  handleWillModalActions = (willAcceptance) => {
    if(willAcceptance){

      WillHelper.processWillLead({
        will_send_lead: willAcceptance ,
        leadDetails: this.getWillLeadDetails()
      })
      this.setState({userAcceptedFreeWill: willAcceptance})
    }

    this.setState({ showWantsFreePineappleWillModal: false}, () => {
      this.retrieveUser()
    })
    
  }

  getFormProgress = () => {
    const total = 5 // number of things that constitute 100%
    let completed = 0 // start at 0

    if (Validators.isName(this.state.firstName)) { completed += 1 } // first name
    if (Validators.isName(this.state.lastName)) { completed += 1 } // last name
    if (Validators.isEmail(this.state.email)) { completed += 1 } // email
    if (Validators.isCellNo(this.state.contactNumber)) { completed += 1 } // cell no
    if ( // number plate
      !this.state.hasNoNumberPlate && Validators.isNumberPlate(this.state.numberPlate)
      || this.state.hasNoNumberPlate
    ) { completed += 1 }

    const progressCurrentPage = (completed / total * 100)
    const progressTotal = progressCurrentPage  / 3 // divide by 3 because this is section 1 of 3
    this.setState({ progressTotal, progressCurrentPage })
  }

  validateFirstName = (onBlur=false) => {
    const { firstName } = this.state

    const valid = Validators.isName(firstName)

    this.setState({
      validFirstName: valid,
      firstNameErrorText: valid
        ? undefined
        : onBlur ? validationMessages.firstName: undefined,
    })
  }

  isReferrerBlocked = (referrer_website) => {
    if (!referrer_website) return true

    const isUrlBlocked = BLOCKED_REFFERER_URLS.includes(referrer_website)
    const isUrlFromPineapple = referrer_website.includes('pineapple')
    const isUrlFromOneLink = referrer_website.includes('onelink')

    return isUrlBlocked || isUrlFromPineapple || isUrlFromOneLink
  }

  validateLastName = (onBlur=false) => {
    const { lastName } = this.state

    const valid = Validators.isName(lastName)

    this.setState({
      validLastName: valid,
      lastNameErrorText: valid
        ? undefined
        : onBlur ? validationMessages.lastName : undefined,
    })
  }

  validateEmail = (onBlur=false) => {
    const { email } = this.state
    const valid = Validators.isEmail(email)

    this.setState({
      validEmail: valid,
      emailErrorText: valid
        ? undefined
        : onBlur ? validationMessages.email : undefined,
    })
  }

  validateContactNumber = (onBlur=false) => {
    const { contactNumber } = this.state
    const valid = Validators.isCellNo(contactNumber)

    this.setState({
      validContactNumber: valid,
      contactNumberErrorText: valid
        ? undefined
        : onBlur ? validationMessages.contactNumber : undefined,
    })
  }

  validateNumberPlate = (onBlur=false) => {
    const { numberPlate, hasNoNumberPlate } = this.state
    if (!hasNoNumberPlate) {
      const valid = Validators.isNumberPlate(numberPlate)

      this.setState({
        validNumberPlate: valid,
        numberPlateErrorText: valid
          ? undefined
          : onBlur ? validationMessages.numberPlate : undefined,
      })
    }
  }

  setFirstName = firstName => this.setState({ firstName }, this.validateFirstName)
  setLastName = lastName => this.setState({ lastName }, this.validateLastName)
  setEmail = email => this.setState({ email }, this.validateEmail)
  setContactNumber = contactNumber => this.setState({ contactNumber }, this.validateContactNumber)
  setRegistrationNumber = numberPlate => this.setState({ numberPlate }, this.validateNumberPlate)

  retrieveDealership = async () => {
    const { dealershipCode } = this.state
    if (!dealershipCode) return
    // retrieve the dealership
    const response = await DealershipService.retrieveDealership(dealershipCode.trim())
    if (response && response.success && response.data) {
      const { dealership } = response.data
      // save the dealership in state
      this.setState({ dealership, dealershipCode: dealership.uuid, displayDealershipCodeInput: true })
    }
  }

  retrieveUser = async () => {
    this.setState({ isRetrievingUser: true })
    // check if the current user is a sales agent
    let retrievingUserTimer
    const externalLeadSource = await Helpers.getInStorage('externalLeadSource')
    const { 
      firstName,
      lastName,
      email,
      contactNumber,
      hippoPayload,
      userId,
      numberPlate,
      hasNoNumberPlate,
      dealership,
      isQueryStringId,
      userAcceptedFreeWill,
      salesAgent,
      ucid,
      ved,
    } = this.state
    // referrerWebsite is saved via cross-browser messaging from www.pineapple.co.za to App.js in this project
    // else we check if the current page has a referrer
    let referrerWebsite = await Helpers.getInStorage('referrerWebsite', true)
    if (!referrerWebsite){
      referrerWebsite = document.referrer
    }
    // get the UCID from storage, this is also sent from www.pineapple.co.za to App.js
    let referrerUcid = await Helpers.getInStorage('ucid', true)

    // verify if we can send the ucid and/ or the referrer website
    const canSendUcid = !salesAgent
    const canSendReferrerWebsite = referrerWebsite && referrerWebsite.trim() !== '' && !salesAgent && !this.isReferrerBlocked(referrerWebsite)

    // handle fallback UCID's in case a user comes directly to this page from another site
    if (!referrerUcid) {
      if (!referrerWebsite) {
        referrerUcid = 'PINCARDIR0001'
      } else if (referrerWebsite === 'https://www.google.com/' || referrerWebsite === 'https://www.google.co.za/') {
        referrerUcid = 'PINCARGORG0001';
      } else if (referrerWebsite === 'https://www.bing.com/') {
        referrerUcid = 'PINCARBORG0001';
      } else if (referrerWebsite && canSendReferrerWebsite) {
        referrerUcid = 'PINCARREF0001'
      }
    }

    const params = {
      user_id: userId,
      first_name: firstName,
      last_name: lastName,
      email,
      contact_number: contactNumber,
      hippo_payload: hippoPayload,
      dealership_code: dealership && dealership.uuid ? dealership.uuid : '',
      isWebUser: true,
      externalLeadSource,
      ...(salesAgent ? {} : Helpers.getUserMetaData(this.state.previousUrl)),
      ...(canSendUcid && referrerUcid ? 
        { referrer: referrerUcid } : {}),
      ...(canSendReferrerWebsite && referrerWebsite ?
        { referrer_website: referrerWebsite } : {})
    }

    // time out after 30 secs if no response
    if(isQueryStringId) {
      retrievingUserTimer = setTimeout(() => {
        this.setState({ isRetrievingUser: false })
        return Alert.alert('Could not retrieve your details',
        'An error occurred while processing your request. Please try again later.'
        )
      }, 30000)
    }

    // clear the referrer website from storage
    await Helpers.removeFromStorage('referrerWebsite', true)
    const response = await MotorService.retrieveUser(params)
    clearTimeout(retrievingUserTimer)
    this.setState({ isRetrievingUser: false })

    // something went wrong
    if (!response?.success) {  
      // remove userId to allow user with non-existent
      // uuid to continue motor flow normally
      this.setState({ userId: null })

      if (response?.error?.isVerifyAccount) {
        this.setState({
          verifyAccountUserId: response.error.userId,
          verifyContactNumber: response.error.verifyContactNumber 
        })
        return Alert.alert('Could not retrieve your details', response.error.message,
        [
          {
            text: 'Ok',
          },
          {
            text: 'Verify',
            onClick: async () => {
              this.setState({ 
                showValidateAccountPopup: true,
                isVerifySMS: true 
              })
            },
          },
        ])
      }

      return Alert.alert('Could not retrieve your details', response?.error?.message || 'An error occurred while processing your request. Please try again later.')
    } 

    // all went well - clear storage and start over
    Helpers.clearStorage()

    await Helpers.setAuthUser(response.data)

    if (userAcceptedFreeWill !== ''){
      await WillHelper.processWillLead({
        user_id: response.data.id,
        will_send_lead: userAcceptedFreeWill,
        leadDetails: this.getWillLeadDetails()
      })
    }

    await Helpers.setInStorage('userAlreadyAcceptedFreeWill', JSON.stringify(userAcceptedFreeWill === '' ? false : userAcceptedFreeWill))

    if (dealership) await Helpers.setInStorage('dealership', JSON.stringify(dealership))

    // if there is an external_lead_source carry that through to the rest of the motor flow
    if (externalLeadSource) {
      await Helpers.setInStorage('externalLeadSource', externalLeadSource)
    }

    // add user_id to smartlook
    smartlook('identify', response.data?.id.toString())

    // identify postHog User
    AnalyticsManager.identifyUser(response.data?.id.toString(), {
      email: email,
      name: `${firstName} ${lastName}`
      }
    )

    // register static event details
    AnalyticsManager.registerStaticEventDetails({
      platform: 'web',
      entity: salesAgent ? 'agent' : 'user',
      ...(salesAgent ? {
        entity_name: `${salesAgent.first_name} ${salesAgent.last_name}`,
        entity_email: salesAgent.email,
      } : {
        entity_name: `${firstName} ${lastName}`,
        entity_email: email,
      })
    })

    // if has number plate, set it
    if (!hasNoNumberPlate) {
      await Helpers.setInStorage('numberPlate', Helpers.replaceAllInString(numberPlate, ' ', ''))
    }

    await Helpers.setInStorage('hasNoNumberPlate', hasNoNumberPlate)

    await Helpers.setInStorage('ved', `${ved}`)
        
    // initiate Intercom
    IntercomManager.init()
    tag.sendWebEvent({
      first_name: firstName,
      last_name: lastName,
      email,
      contact_number: contactNumber,
      event_name: 'new_user_registration'
    })

    // Prevent redirect to dashboard if user has no contact_number
    if (response && response.data && !response.data.contact_number) {
      const {
        first_name,
        last_name,
        email,
      } = response.data

      if (first_name && first_name.trim() !== '') {
        this.setFirstName(first_name)
      }

      if (last_name && last_name.trim() !== '') {
        this.setLastName(last_name)
      }
      
      if (email && Validators.isEmail(email)) {
        this.setEmail(email)
      }
    } else {
      try {
        const {
          first_name,
          last_name,
          email,
          contact_number,
          id
        } = response.data

        await Helpers.addDataLayer({ 
          event: 'get-started',
          uuid: id?.toString(),
          ucid: ucid,
          clientEmail: email,
          clientPhone: contact_number,
          clientFirstName: first_name,
          clientLastName: last_name,
        })
      }
      catch (error) {
        // console.error('Error adding data layer', error)
      }

      !salesAgent && SmartDelayService.init()

      await this.checkForExistingVehicles()
    }
  }

  checkForExistingVehicles = async () => {
    const { experimentName, variantName, salesAgent } = this.state
    const numberPlate = Helpers.replaceAllInString(this.state.numberPlate, ' ', '')

    // get all user's saved vehicle
    this.setState({ isRetrievingUser: true })
    const vehiclesResponse = await MotorService.getVehicles({ insured: false })
    this.setState({ isRetrievingUser: false })

    const vehicles = vehiclesResponse.success ? vehiclesResponse.data : null

    let existingVehicle

    if (vehicles && vehicles.length) {
      await Helpers.setInStorage('vehicles', JSON.stringify(vehicles))

      vehicles.some((vehicle) => {
        if (vehicle.registration.toUpperCase() === numberPlate.toUpperCase()) {
          existingVehicle = vehicle
          return true
        }
      })
    }

    // Capture event for A/B testing
    AnalyticsManager.captureEvent('user_signed_up')
    // Capture the event in the database for A/B testing
    if (experimentName && variantName) {
      // save the experimentName and variantName in local storage
      await Helpers.setInStorage('experimentName', experimentName)
      await Helpers.setInStorage('variantName', variantName)
      await AnalyticsManager.trackExperiment(experimentName, variantName, salesAgent, existingVehicle);
    }

    // if found, give user option to use it
    if (existingVehicle) {
      const modelTruncateIndex = existingVehicle.model.indexOf('[')
      const model = existingVehicle.model.substring(0, modelTruncateIndex)

      return Alert.alert(
        'You\'ve added this car before - we can save you some time! ⏱',
        `We have a ${existingVehicle.year} ${existingVehicle.make} ${model} on record for this registration. You can save time on filling this form out by using it now.`,
        [
          {
            text: 'Insure another vehicle',
            style: 'cancel',
            onClick: () => this.setState({ numberPlate: '' })
          },
          {
            text: 'Use it',
            onClick: () => this.useVehicle(existingVehicle)
          },
        ]
      )
    } else if (vehicles && vehicles.length) {
      return this.setState({ redirect: true })
    }
    else {
      // no existing vehicle - go to next page
      return this.setState({ redirectToVehicleDetails: true })
    }
  }

  useVehicle = async (vehicle) => {
    await Helpers.setInStorage('vehicle', JSON.stringify(vehicle))
    this.setState({ redirect: true })
  }

  renderThirdPartyInfoPopup = () => {
    const {
      showThirdPartyInfoPopup
    } = this.state

    return (
      <PopupView
        visible={showThirdPartyInfoPopup}
        title="Third Party Information Sharing"
        onPressClose={() => this.setState({ showThirdPartyInfoPopup: false })}
        renderContent={() => {
          return (
            <div>
              <p>
                This application will serve as the basis of an insurance contract. The information you supply will determine your premium, its acceptance and terms and conditions of your application.
              </p>
              <p>
                We need to obtain your personal information to calculate a premium and to form the basis of any policy that may be taken out, and to provide our products and services to you. This may require sharing your information with service providers, for example credit bureaus to perform ITC checks, laws enforcement, fraud prevention, and other regulatory bodies.
              </p>
              <p>
                By clicking “Start” you consent to providing and sharing your personal information.
              </p>
            </div>
          )
        }}
      />
    )
  }

  renderCreditChecksPopup = () => {
    const {
      showCreditChecksPopup
    } = this.state

    return (
      <PopupView
        visible={showCreditChecksPopup}
        title="Credit Checks"
        onPressClose={() => this.setState({ showCreditChecksPopup: false })}
        renderContent={() => {
          return (
            <div>
              <p>
                This application will serve as the basis of an insurance contract. The information you supply will determine your premium, its acceptance and terms and conditions of your application.
              </p>
              <p>
                We need to obtain your personal information to calculate a premium and to form the basis of any policy that may be taken out, and to provide our products and services to you. This may require sharing your information with service providers, for example credit bureaus to perform ITC checks, laws enforcement, fraud prevention, and other regulatory bodies.
              </p>
              <p>
                By clicking “Start” you consent to providing and sharing your personal information.
              </p>
            </div>
          )
        }}
      />
    )
  }

  sendOTP = async() => {
    const {isVerifySMS, verifyAccountUserId} = this.state
    this.setState({isSendingOtp: true})
    if (isVerifySMS) {
      const sms_type = 'verify_contact_number_web'
      const sendSMSResponse = await MotorService.sendSMS(verifyAccountUserId, sms_type)
      if(!sendSMSResponse.success) {
        this.setState({isOtpSent: false, showValidateAccountPopup:false, isSendingOtp: false})
        Alert.alert('Something went wrong sending OTP', 'An error occured while processing your request. Please try again later')
      } else {
        this.setState({ isOtpSent: true, isSendingOtp: false })
      }
    }
  }

  verifyEmail = async () => {
    const { userId, verifyEmailAddress } = this.state
      const response = await MotorService.verifyEmail(userId, verifyEmailAddress)
      if (response && response?.success) {
        Alert.alert('Email verified', 'Thank you. Your email has been successfully verified')
      } else {
        Alert.alert('Email verification failed', ' An error occurred while processing your request. Please try again later')
      }
  }
  

  confirmOTP = async() => {
    const { verifyContactNumber, verifyAccountUserId, otp, email } = this.state
    const verifyCodeParams = {
      code: otp,
      contact_number: verifyContactNumber,
      user_id: verifyAccountUserId
    }

    this.setState({isConfirmingOtp: true})
    const verifyResponse = await MotorService.verifySMS(verifyCodeParams)
    this.setState({isConfirmingOtp: false})
    if (verifyResponse.success) {
      this.setState({showValidateAccountPopup: false})
      //update and redirect
      const updateUserParams = {
        email,
        verifyContactNumber,
      }
      const updateUserResponse = await MotorService.updateUserOnVerifyAccount(verifyAccountUserId, updateUserParams)
      if (updateUserResponse.success) {
        Alert.alert('Success!', 'Thank you, account verified successfully')
        this.setState({email, contactNumber: verifyContactNumber })
        this.retrieveUser()
      } else {
        Alert.alert('Error', 'something went wrong updating account details')
      }
    } else {
      Alert.alert('Error', 'Something went wrong verifying account')
    }
  }

  renderVerifyAccountPopup = () => {
    const {
      isOtpSent,
      otp,
      isSendingOtp,
      isConfirmingOtp,
      verifyContactNumber,
      showValidateAccountPopup,
      isVerifySMS,
      isVerifyEmail
    } = this.state

    const phoneCode = verifyContactNumber ? verifyContactNumber.substring(0, 3) : null
    const phoneLast = verifyContactNumber ? verifyContactNumber.substring(6, 10) : null
    return (
      <PopupView
        visible={showValidateAccountPopup}
        title="Verify Account"
        width={'auto'}
        onPressClose={() => this.setState({ showValidateAccountPopup: false })}
        renderContent={() => {
          return (
            <div>
              <div style={styles.verifyAccountFormInputContainer} className='verify-account-form-input-container' >
                <amp-img src={pineappleLogo} style={{ height: '100px' }} />
                <p style={styles.verifyAccountHeading} className='verify-account-heading' >
                  Verify Account
                </p>
                <p style={styles.verifyAccountSubHeading} className='verify-account-sub-heading'>
                  Before you can continue we need to verify your account.
                </p>
                <p style={styles.verifyAccountSubHeading} className='verify-account-sub-heading'>
                  We will send a verification code via SMS.
                </p>
                <div>
                  {
                    isSendingOtp ? (
                      <ActivityIndicator />
                    ) : (
                      <Button
                        title={isOtpSent ? 'Resend code' : 'Send code'}
                        disabled={!isVerifySMS && !isVerifyEmail}
                        color={'#68C9D0'}
                        onClick={this.sendOTP}
                      />
                    )
                  }
                </div>
                {
                  isOtpSent ? (
                    <div className='verify-account-otp-sent-container'>
                      <div className='verify-account-otp-sent-confirmation-container'>
                        <p>We have sent a verification code to <span style={{ fontWeight: 'bold' }}>{`${phoneCode} *** ${phoneLast}`}</span></p>
                        <p>Please enter the code below.</p>
                      </div>
                      <div style={{ width: '60%' }}>
                        <NumberInput
                          label={'Verification Code'}
                          placeholder={'e.x 2468'}
                          value={otp}
                          isValid={otp ? true : false}
                          isVerifyAccount={true}
                          onChange={(e) => { this.setState({ otp: e.target.value }) }}
                        />
                      </div>
                    </div>
                  ) : null
                }
              </div>
              <div style={styles.verifyAccountConfirmButtonContainer} className='verify-account-confirm-button-container'>
                {
                  isConfirmingOtp ? (
                    <ActivityIndicator />
                  ) : (
                    <Button
                      title={'Confirm code'}
                      disabled={!isOtpSent || !otp}
                      color={'#68C9D0'}
                      onClick={this.confirmOTP}
                    />
                  )
                }
              </div>
            </div>
          )
        }
        }
      />
    )
  }

  renderWillsProductOptInVariant = (isDealership, isAgent) => {
    posthog.onFeatureFlags(async() => {
      // render the appropriate variant
      if (isDealership || isAgent) {
        // force the checkbox variant if an agent is logged in or dealership link is used
        await AnalyticsManager.forceExperimentVariant('wills-opt-in', 'wills-checkbox-opt-in')
      }
      let experimentVariant = await AnalyticsManager.getExperimentVariant('wills-opt-in')
      switch (experimentVariant) {
        case 'wills-checkbox-opt-in':
          this.setState({
            showWillsCheckbox: true,
            experimentName: 'wills-opt-in',
            variantName: 'wills-checkbox-opt-in'
          })
          break
        case 'wills-popup-opt-in':
          this.setState({
            showWillsPopup: true,
            experimentName: 'wills-opt-in',
            variantName: 'wills-popup-opt-in'
          })
          break
        case 'control':
          this.setState({
            hideWillsProduct: true,
            experimentName: 'wills-opt-in',
            variantName: 'control'
          })
          break
        default:
          // if experimentVariant is undefined, default to the control
          this.setState({
            hideWillsProduct: true,
            experimentName: 'wills-opt-in',
            variantName: 'control'
          })
          break
      }
    })
  }

  render = () => {
    if (this.state.redirect) {
      return <Redirect push to="/car-insurance/dashboard" />
    }

    if (this.state.redirectToVehicleDetails) {
      return (
      <Redirect push to={{
        pathname: '/car-insurance/vehicle-details',
        state: { fromGetStarted: true }, 
      }}
        />
      )
    }

    const {
      firstName,
      validFirstName,
      firstNameErrorText,
      lastName,
      validLastName,
      lastNameErrorText,
      email,
      validEmail,
      emailErrorText,
      contactNumber,
      validContactNumber,
      contactNumberErrorText,
      canSubmitForm,
      progressTotal,
      dealershipCode,
      displayDealershipCodeInput,
      validNumberPlate,
      numberPlateErrorText,
      hasNoNumberPlate,
      wantsFreePineappleWill,
      showWillsCheckbox,
      canSubmitWillLead,
    } = this.state

    return (
      <div className="parent-container">
        <Navigation product={productTypes.motor} />
        <div style={{...styles.content, ...styles.backgroundPages}} className="content content__motor-get-started-page grid-x">
          <div style={styles.contentPageLeftRight} className="cell large-6 content__motor-get-started-page--left motor-get-started-content__wrapper">
            <div className="content-box content-box--margin-top content-box--padding-left-and-right">
              <h1 style={styles.motorGetStartedContentHeading} className="motor-get-started-content__Heading motor-get-started-content__Heading--mobile-large motor-get-started-content__Heading--main-heading">Hi there!</h1>
              <h2 style={styles.motorGetStartedContentSubHeading} className="motor-get-started-content__Sub-Heading">
                Are you ready to roll?
              </h2>
              <p style={styles.motorGetStartedContentText} className="motor-get-started-content__Text">
                First... We need a few details to get you going.
                <br />The more you give us, the better your price.
              </p>
              <div className='progress-step-indicator-container'>
                <ProgressStepIndicator step={0} progressTotal={Math.round(progressTotal)} product={productTypes.motor} />
              </div>
            </div>
          </div>
          <div className="cell large-6 content__motor-get-started-page--right">
            <div className="content-box content-box--margin-bottom content-box--is-shadowed content-box--is-padded content-box--limit-max-width content-box--background-blue">
              <h1 className="motor-get-started-content__Heading motor-get-started-content__Heading--sub-heading">
                Let's get started
              </h1>
              <hr className={'divider divider--is-dark-gray divider--is-margin-20px'} />
              <ChatBot ref={this.chatBotRef} />
              {this.state.isRetrievingUser ? (
                <div style={styles.getStartedActivityIndicatorContainer} className="get-started-activity-indicator-container">
                  <ActivityIndicator />
                  </div>
                ) : (
              <>
                    <div className="grid-x grid-padding-x">
                      <div className="cell large-6 flex-1 pe-2">
                        <TextInput
                          label={'Name'}
                          placeholder={'First Name'}
                          name={'firstName'}
                          onChange={event => this.setFirstName(event.target.value)}
                          onBlur={() => {
                            this.validateFirstName(true)
                            validFirstName && this.chatBotRef.current.speak('GetStarted_FirstName_Greet', firstName)
                            this.setState({ editable: false })
                          }}
                          isValid={validFirstName}
                          value={firstName}
                          idName={'motor-get-started-first-name'}
                          errorMessage={firstNameErrorText}
                          onFocus={() => {
                            this.setState({ editable: true }) // Allow editing when the input is focused
                          }}
                          customEventName={'GetStarted_FirstName'}
                        />
                      </div>
                      <div className="cell large-6 flex-1 ps-2">
                        <TextInput
                          label={'Surname'}
                          placeholder={'Last Name'}
                          name={'lastName'}
                          onChange={event => this.setLastName(event.target.value)}
                          onBlur={() => {
                            this.validateLastName(true)
                            this.setState({ editable: false })
                          }}
                          isValid={validLastName}
                          value={lastName}
                          idName={'motor-get-started-last-name'}
                          errorMessage={lastNameErrorText}
                          customEventName={'GetStarted_LastName'}
                          onFocus={() => {
                            this.setState({ editable: true }) // Allow editing when the input is focused
                          }}
                        />
                      </div>
                    </div>
                <div className="grid-x grid-padding-x">
                  <div className="cell large-12">
                    <TextInput
                      label={'Email'}
                      placeholder={'Email'}
                      name={'email'}
                      onChange={event => this.setEmail(event.target.value.trim())}
                      onBlur={()=>this.validateEmail(true)}
                      isValid={validEmail}
                      value={email}
                      idName={'motor-get-started-email'}
                      errorMessage={emailErrorText}
                      customEventName={'GetStarted_Email'}
                    />
                  </div>
                </div>
                <div className="grid-x grid-padding-x">
                  <div className="cell large-12">
                    <TextInput
                      label={'Contact Number'}
                      placeholder={'Contact Number'}
                      name={'contactNumber'}
                      onChange={event => this.setContactNumber(event.target.value)}
                      type={'number'}
                      onBlur={()=>this.validateContactNumber(true)}
                      isValid={validContactNumber}
                      value={contactNumber ? contactNumber.trim() : ''}
                      idName={'motor-get-started-contact-number'}
                      errorMessage={contactNumberErrorText}
                      customEventName={'GetStarted_ContactNumber'}
                    />
                  </div>
                </div>
                {
                  displayDealershipCodeInput &&
                  <div className="grid-x grid-padding-x">
                    <div className="cell large-12">
                      <TextInput
                        label={'Dealership Code'}
                        placeholder={'Dealership Code'}
                        name={'dealershipCode'}
                        editable={false}
                        disabled={true}
                        isValid={dealershipCode}
                        value={dealershipCode}
                        errorMessage={'*This is your Dealership Code'}
                        idName={'motor-get-started-dealership-code'}
                      />
                    </div>
                  </div>
                }
                <div className="grid-x grid-padding-x">
                  <fieldset className="large-12 cell">
                    <CheckboxInput
                      label={'I don\'t have a number plate yet'}
                      isChecked={this.state.hasNoNumberPlate}
                      onChange={(event) =>
                        this.setState({ hasNoNumberPlate: event.target.checked }, () =>
                          this.validateNumberPlate()
                        )
                      }
                      idName={'motor-get-started-no-number-plate-checkbox'}
                    />
                  </fieldset>
                </div>
                <div className="grid-x grid-padding-x">
                  <div className="cell large-12">
                    <NumberplateInput
                      label={'Number Plate'}
                      placeholder={
                        hasNoNumberPlate ? '' : 'ex. PINE 123 GP'
                      }
                      name={'numberPlate'}
                      onChange={(event) =>
                        this.setRegistrationNumber(event.target.value)
                      }
                      onBlur={()=>this.validateNumberPlate(true)}
                      isValid={hasNoNumberPlate || validNumberPlate}
                      value={hasNoNumberPlate ? '' : this.state.numberPlate.toUpperCase()}
                      idName={'motor-get-started-number-plate'}
                      errorMessage={numberPlateErrorText}
                      disabled={!!hasNoNumberPlate}
                    />
                  </div>
                </div>
                  {showWillsCheckbox && canSubmitWillLead && <div className="grid-x grid-padding-x w will-vertical-margin">
                  <fieldset className="large-12 cell">
                    <CheckboxInput
                      label={'Get Your Complimentary Will Drafting & Optional Legacy Protection Plan.'}
                      // subText={'(valued at R7,999.98)'}
                      isChecked={wantsFreePineappleWill}
                      onChange={(event) => {
                        this.setState({ wantsFreePineappleWill:  event.target.checked, userAcceptedFreeWill: event.target.checked })
                        WillHelper.processWillLead(
                          {
                            will_send_lead: event.target.checked,
                            leadDetails: this.getWillLeadDetails()
                          })
                      }}
                      idName={'motor-get-started-wants-free-pineapple-will-checkbox'}
                    />
                  </fieldset>
                </div>}

                <div className="action-button-wrapper action-button-wrapper--center-content action-button-wrapper--margin-bottom">
                    <Button
                      title={'Start'}
                      color={'transparent'}
                      disabled={!canSubmitForm}
                      onClick={()=>{
                        // temporary fix to prevent the will modal from showing to improve lead quality
                        //this.state.showWillsPopup ?
                        //this.setState({showWantsFreePineappleWillModal: !this.state.showWantsFreePineappleWillModal}) : this.retrieveUser()
                        this.retrieveUser()
                      }}
                      idName={'motor-get-started-start-button'}
                    />
                </div>
              </>)}
              <div className="">
                <p className="motor-get-started-content__Sub-Text motor-get-started-content__Sub-Text--is-centered">
                  By clicking 'Start' you agree to <a className="motor-get-started__link" href={'https://www.pineapple.co.za/terms-and-conditions/'} target="_blank">Ts &amp; Cs</a>, <a className="motor-get-started__link" href={'https://terms.pineapple.co.za/popi'} target="_blank">POPI requirements</a>, <a className="motor-get-started__link" onClick={() => this.setState({ showThirdPartyInfoPopup: true })} target="_blank">3rd party information sharing</a> and <a className="motor-get-started__link" onClick={() => this.setState({ showCreditChecksPopup: true })}>credit checks</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <WillModal firstName={firstName} handleWillModalActions={this.handleWillModalActions} showWantsFreePineappleWillModal={this.state.showWantsFreePineappleWillModal}/>
        {this.renderThirdPartyInfoPopup()}
        {this.renderCreditChecksPopup()}
        {this.renderVerifyAccountPopup()}
      </div>
    )
  }
}

const styles = {

  cell: {
    paddingLeft: '0!important',
    paddingRight: '0!important',
  },
  content: {
    position: 'relative',
    minHeight: '100vh',
    paddingBottom: '9rem',
    display: 'flex',
    flex: 1
  },
  motorGetStartedContentHeading: {
    fontWeight: 600,
    lineHeight: '68px',
    letterSpacing: '2px',
  },
  motorGetStartedContentSubHeading: {
    fontWeight: 600,
    marginBottom: '20px',
    fontSize: '18px',
  },
  motorGetStartedContentText: {
    fontWeight: 500,
    fontSize: '16px',
  },
  getStartedActivityIndicatorContainer:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
  },
  backgroundPages: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'bottom left',
    backgroundAttachment: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },

  contentPageLeftRight: {
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  verifyAccountFormInputContainer: {
    textAlign: 'center',
    alignContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: '50px',
  },
  verifyAccountHeading: {
    fontWeight: 600,
    fontSize: '25px',
    marginTop: '5px',
  },
  verifyAccountSubHeading: {
    fontWeight: 600,
    fontSize: '17px',
    marginTop: '10px',
    marginBottom: '50px',
    width: '50%',
  },
  verifyAccountConfirmButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '25px',
  },
  selectRadioButtonText: {
    color: '#000',
    fontSize: '13px',
    fontWeight: 300,
    marginTop: '10px',
  },
  radioButtonsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px',
  },

  actionButtonWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15,
  },
}

export default MotorGetStartedPage
